import { useState } from 'react'

import PropTypes from 'prop-types'

import { ConfirmationDialog, LoadingFeedback } from 'components'

import constants from 'constants/index'
import helpers from 'helpers'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

const OrganizationCompanyRemoveDialog = ({
  currentOrganizationCompany,
  organization,
  open,
  setOpen = () => {},
  refresh = () => {},
}) => {
  const snackbar = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)

  const { GOVERNANCE_PROJECTS_ARCHIVE_WARNING } = constants.organizations

  const noticeText = `Você tem certeza que deseja desvincular a empresa
                      ${currentOrganizationCompany?.company?.name}
                      do Grupo Advisor ${organization?.name}?
                      Após confirmar, essa empresa não pertencerá mais a esse Grupo Advisor.`

  const onSubmit = async (currentOrganizationCompany) => {
    try {
      setIsLoading(true)

      await service.backoffice.organizationCompanies.destroy({
        organizationId: organization?.id,
        id: currentOrganizationCompany?.id,
      })

      snackbar.open({
        message: 'Empresa desvinculada com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao desvincular empresa!',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
      setOpen(false)
      refresh()
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <ConfirmationDialog
        open={open}
        setOpen={setOpen}
        message={noticeText}
        alert={GOVERNANCE_PROJECTS_ARCHIVE_WARNING}
        alertColor="error"
        buttonText="Confirmar"
        actionAcceptButton={() => onSubmit(currentOrganizationCompany)}
      />
    </>
  )
}

OrganizationCompanyRemoveDialog.propType = {
  currentOrganizationCompany: PropTypes.object,
  organization: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  refresh: PropTypes.func,
}

export default OrganizationCompanyRemoveDialog
